module.exports = __webpack_public_path__ + "img/nursing.313d491b.png";